import React from 'react'
import { useEffect, useState } from "react";
import Menu from '../Menu';

const CheckShareAlarms = () => {

  const [responseText, setResponseText] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Loader state


    useEffect(() => {
        fetch("https://app64.heliohost.us/checkShares/checkShares.php")
        .then((response) => response.text()) // Read response as text
        .then((text) => {
          setResponseText(text);
          setIsLoading(false); // Stop loader when data is received

        }

        )
        .catch((error) => {
          console.error("Error fetching data:", error)
          setIsLoading(false); // Stop loader when data is received

        }
        );
  }, []);
      

  return (
    <div>
      <Menu/>
      <h1>API Data</h1>

      {isLoading ? <p>Loading...</p> : <pre>{responseText}</pre>} 

    </div>
  )
}

export default CheckShareAlarms